/**
 * Serves the public PostHog project configuration to the browser.
 *
 * The project token (`phc_...`) is a publishable ingest key, so exposing it
 * to the client is expected by PostHog. It is still read from Lovable Cloud
 * secrets at runtime rather than hardcoded, so rotating the secret takes
 * effect without a rebuild.
 */
import { createServerFn } from "@tanstack/react-start";

export type PostHogPublicConfig = {
  enabled: boolean;
  apiKey: string;
  apiHost: string;
};

export const getPostHogConfig = createServerFn({ method: "GET" }).handler(
  async (): Promise<PostHogPublicConfig> => {
    const apiKey = (process.env.POSTHOG_API_KEY ?? "").trim();
    const region = (process.env.POSTHOG_REGION ?? "us").trim().toLowerCase();
    const fallback = region === "eu" ? "https://eu.i.posthog.com" : "https://us.i.posthog.com";
    const apiHost = (process.env.POSTHOG_HOST ?? "").trim().replace(/\/+$/, "") || fallback;
    return { enabled: !!apiKey, apiKey, apiHost };
  },
);